import React, { createContext, useContext, useState, useCallback } from 'react';
import "./AlertContext.css"
// types.ts
export type AlertType = 'success' | 'error' | 'info' | 'warning';

export interface Alert {
  id: string;
  type: AlertType;
  message: string;
}

interface AlertContextType {
  showAlert: (message: string, type: AlertType) => void;
}

const AlertContext = createContext<AlertContextType | undefined>(undefined);

export const AlertProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [alerts, setAlerts] = useState<Alert[]>([]);

  const showAlert = useCallback((message: string, type: AlertType) => {
    const id = Math.random().toString(36).substr(2, 9);
    // setAlerts((prev) => [...prev, { id, message, type }]);
    setAlerts([{ id, message, type }]);
    // Auto-remove after 4 seconds
    setTimeout(() => {
      setAlerts((prev) => prev.filter((alert) => alert.id !== id));
    }, 4000);
  }, []);

  return (
    <AlertContext.Provider value={{ showAlert }}>
      {children}
      {/* The Portal for UI */}
      <div className="alert-container">
        {alerts.map((alert) => (
          <div key={alert.id} className={`alert-box ${alert.type}`}>
            <span className="icon">{getIcon(alert.type)}</span>
            <p>{alert.message}</p>
          </div>
        ))}
      </div>
    </AlertContext.Provider>
  );
};

export const useAlert = () => {
  const context = useContext(AlertContext);
  if (!context) throw new Error('useAlert must be used within AlertProvider');
  return context;
};

// Simple helper for icons
const getIcon = (type: AlertType) => {
  switch (type) {
    case 'success': return '✓';
    case 'error': return '✕';
    default: return 'ℹ︎';
  }
};